type ExportUser = {
  role?: { roleTechnicalName?: string | null } | null;
  isRoot?: boolean | null;
} | null | undefined;

function isAgentSession(
  user: ExportUser,
  sessionIsRoot?: boolean | null
): boolean {
  return Boolean(sessionIsRoot ?? user?.isRoot);
}

// [AI_START::function id="canRequestDealerExport" purpose="Only this dealership's Admin (technical role root) may start an export; derived isRoot is a parent-org session" links=["FullExportButton", "clients"]]
export function canRequestDealerExport(
  user: ExportUser,
  sessionIsRoot?: boolean | null
): boolean {
  return (
    user?.role?.roleTechnicalName === "root" &&
    !isAgentSession(user, sessionIsRoot)
  );
}
// [AI_END::canRequestDealerExport]

// [AI_START::function id="canSeeDealerExport" purpose="Show the control to dealership Admin and to a 3Beep agent; hide it from Manager and operators" links=["canRequestDealerExport"]]
export function canSeeDealerExport(
  user: ExportUser,
  sessionIsRoot?: boolean | null
): boolean {
  return (
    isAgentSession(user, sessionIsRoot) ||
    canRequestDealerExport(user, sessionIsRoot)
  );
}
// [AI_END::canSeeDealerExport]
